import { CSSProperties } from 'react';
import { FsComponentSize } from 'globals/types';

export const getFontSize = (size: FsComponentSize): number => {
  if (size === FsComponentSize.L) return 16;
  return 14;
};

export const getCustomTabStyle = (size: FsComponentSize): CSSProperties => ({
  fontSize: getFontSize(size),
});
